/**
 * MUI 9 slot props (`slotProps.input`, `slotProps.textField`, ...) may be an
 * object or a function of the component's owner state. The app composes slot
 * props in its wrappers (AppInput, AppSelect, the pickers) by spreading them,
 * which needs the object form; the wrappers document "object form only" and a
 * function form counts as absent here rather than being called with a made-up
 * owner state.
 */
export const objectSlotProps = <T>(
  value: T | ((ownerState: any) => T) | undefined,
): T | undefined => (typeof value === 'function' ? undefined : value);
